export default "__VITE_ASSET__aShr_ZhT__"